export default __webpack_public_path__ + "static/media/milestone-tier-3.445b40de.png";